// utils

// 手机打码
export const maskmobile = mobile => {
  if (!mobile) return
  return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

// 身份证打码
export const maskIdNumber = id => {
  return id.replace(/^(.{6})(.*)(.{4})$/, '$1********$3')
}
// 邮箱打码
export const maskemail = value => {
  if (String(value).indexOf('@') > 0) {
    let str = value.split('@')
    let _s = ''
    if (str[0].length > 3) {
      for (let i = 0; i < str[0].length - 3; i++) {
        _s += '*'
      }
    }
    let newEmail = str[0].substr(0, 3) + _s + '@' + str[1]
    return newEmail
  }
}

// 姓名打码
export const maskName = name => {
  if (name.length < 2) {
    return
  }
  let arr = name.split('')
  if (arr.length === 2) {
    return arr[0] + '*'
  } else {
    return arr[0] + '*' + (arr[arr.length - 1])
  }
}



// WEBPACK FOOTER //
// ./src/common/utils.js